import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import app from './modules/app'

Vue.use(Vuex)

const getters = {
  token: state => state.user.token,
  name: state => state.user.name,
  avatar: state => state.user.avatar,
  role: state => state.user.role,
  sidebar: state => state.app.sidebar
}

export default new Vuex.Store({
  modules: {
    user,
    app
  },
  getters
})
